<template>
  <div>

    <v-select
        outlined
        dense
        :value="settings.base64File"
        @input="(val) => onUpdate(val, `settings.base64File`)"
        item-text="name"
        item-value="name"
        :items="availableInputFields"
        label="Base64 File"
        clearable
        class="mt-3"
    ></v-select>


    <v-row dense align="center">
      <v-col cols="auto" class="mr-auto">
        <v-switch
            label="Sections from AI Document Analysis"
            v-model="settings.AIDocumentAnalysisSectionsEnabled"
            @change="toogleAIDocumentAnalysisSections"
        >
          Sections from AI Document Analysis
        </v-switch>
      </v-col>
    </v-row>

    <v-row
        class="mb-1"
        dense>
      <v-col cols="11">
        <v-select
            outlined
            dense
            :value="settings?.AIDocInput?.inputNodeId"
            @input="
              (val) =>
                onUpdate(val, `settings.AIDocInput.inputNodeId`)
            "
            @change="changeAIDocInput()"
            item-text="name"
            item-value="id"
            v-if="settings.AIDocumentAnalysisSectionsEnabled"
            :items="availableInputs.filter((i) => i.action_type)"
            label="AI Document Analysis Connector" />
      </v-col>
    </v-row>

    <v-select
        v-if="settings.AIDocumentAnalysisSectionsEnabled"
        outlined
        dense
        :value="settings.AIDocumentAnalysisSections"
        @input="(val) => onUpdate(val, `settings.AIDocumentAnalysisSections`)"
        item-text="name"
        item-value="name"
        :items="availableInputFieldsAIDoc()"
        label="AI Document Analysis Sections"
        clearable
        class="mt-3"
    ></v-select>

    <mustache-template
      v-if="!settings.AIDocumentAnalysisSectionsEnabled"
      class="mt-3"
      label="Starting page numbers"
      placeholder="Array of numbers or comma separated numbers"
      :value="settings.startPageNumbers"
      @input="(val) => onUpdate(val, 'settings.startPageNumbers')"
      :suggestions="availableInputFields"
      :singleLine="true"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import MustacheTemplate from '@/components/mustache/mustache-template.vue';
import cloneDeep from "lodash/cloneDeep";
import {findNode, getInputModel} from '@/util/action-types';
import {shTypes} from "@/util/actionsModels";
import {isObject} from "lodash";

const { mapGetters: workflowDetailsGetters } =
  createNamespacedHelpers('workflows/details');

export default {
  name: 'pdf-split-file',
  props: {
    availableInputFields: { required: true },
    availableInputs: { required: true }
  },
  components: {
    MustacheTemplate,
  },
  data() {
    return {};
  },
  computed: {
    ...workflowDetailsGetters({
      selectedNode: 'SELECTED_NODE',
    }),
    settings() {
      return this.selectedNode.settings;
    },
  },
  methods: {
    onUpdate(value, path) {
      this.$emit('update', value, path);
    },
    inputAction(inputNode) {
      if (
          !inputNode ||
          !inputNode.action_type ||
          !inputNode.actions ||
          !inputNode.actions.length
      )
        return null;
      return inputNode.actions.find(
          (a) => inputNode.action_type === a.action_type
      );
    },
    toogleAIDocumentAnalysisSections(val) {
      const AIDocInput = {
        inputNodeId: null,
        inputFieldId: null,
        inputFieldName: null,
        inputFieldPath: null,
        params: [],
      }
      this.onUpdate(val, `settings.AIDocumentAnalysisSectionsEnabled`);
      this.onUpdate(AIDocInput, `settings.AIDocInput`);
    },
    findNode(id) {
      console.log(this.availableInputs)
      return findNode(this.availableInputs, id);
    },
    getInputModel() {
      const inputNodeId = this.settings?.AIDocInput?.inputNodeId;
      const inputNode = this.findNode(inputNodeId);

      const inputAction = this.inputAction(inputNode);
      const options = {
        inputNodeId,
        inputNode,
        inputAction,
        nodes: this.nodes,
        nodeId: this.selectedNode.id,
      };


      return getInputModel(options);
    },
    changeAIDocInput(index) {
      const settings = cloneDeep(this.settings);
      const inputModel = this.getInputModel(index);
      const inputFields = this.availableInputFieldsAIDoc();

      if (inputFields && inputFields.length) {
        settings.AIDocInput.inputFieldPath = inputModel.name;
        settings.AIDocInput.inputFieldName = inputModel.name;
        settings.AIDocInput.inputFieldId = inputModel.uid;
      }
      this.onUpdate(settings, 'settings');
      this.updateModel();
    },
    availableInputFieldsAIDoc() {
      let result = [];

      const inputModel = this.getInputModel();
      if (inputModel) {
        if (Array.isArray(inputModel)) {
          const items = inputModel
              .filter((item) => item.type === shTypes.ARRAY)
              .map((i) => ({ name: i.name, uid: i.uid, field: i }));
          result.push(...items);
        } else if (
            typeof inputModel === 'object' &&
            inputModel.type === shTypes.ARRAY
        ) {
          const items = [
            {
              name: inputModel.name,
              uid: inputModel.uid,
              field: inputModel,
            },
          ];
          result.push(...items);
        }
        const flattenObjFields = (items, prefix) => {
          if (isObject(items)) {
            items?.forEach((prop) => {
              const propWithPrefix = {
                name: !prefix ? prop.name : `${prefix}.${prop.name}`,
                uid: prop.uid,
                field: prop,
              };

              if (prop.type === shTypes.OBJECT) {
                result.push(propWithPrefix);
                flattenObjFields(prop.value, propWithPrefix.name);
              } else {
                result.push(propWithPrefix);
              }
            });
          }
        };

        if (inputModel.type === shTypes.OBJECT) {
          flattenObjFields(inputModel.value, inputModel.name);
        } else {
          const items = [
            {
              name: inputModel.name,
              uid: inputModel.uid,
              field: inputModel,
            },
          ];
          result.push(...items);
        }
      }

      return result;
    },
  },
};
</script>

<style scoped lang="scss"></style>
